<div>
  <div class="progress-container full-width">
    <div [matTooltip]="tooltip|translate"
      class="progress-bar" [ngClass]="'progress-bar-'+color"
      [style.width.%]="value">{{ value }}%
    </div>
  </div>
</div>
